import { Builder } from "@builder.io/react";
import { PointsCalculator, PointsCalculatorWithFees } from "@/components/Calculator";  
import { registerMenuGroups, commonInputs } from "./helper";

const calculatorComponents = [
  {
    name: "Calculators",
    items: [
      { name: "Points Calculator" },
      { name: "Points Calculator With Fees" },
    ]
  },
];

export const registerCalculatorComponents = () => {
  registerMenuGroups(calculatorComponents);

  Builder.registerComponent(PointsCalculator, {
    name: "Points Calculator",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({
        excludeMicroCopy: false,
      }),
      {
        name: "calculatorItems",
        type: "list",
        defaultValue: [
          {
            tabTitle: "Tab 1",
            conversionRate: 1,
            conversionRateUnit: "points",
            image: "/placeholder.svg",
            imageAltText: "Image Alt Text",
            title: "Title 1",
            content: "Content 1",
            disclaimer: "Disclaimer 1",
          },
          {
            tabTitle: "Tab 2",
            conversionRate: 2,
            conversionRateUnit: "points",
            image: "/placeholder.svg",
            imageAltText: "Image Alt Text",
            title: "Title 2",
            content: "Content 2",
            disclaimer: "Disclaimer 2",
          },
        ],
        subFields: [
          {
            name: "tabTitle",
            type: "text",
          },
          {
            name: "conversionRate",
            type: "number",
            defaultValue: 1.0,
          },
          {
            name: "conversionRateUnit",
            type: "text",
            defaultValue: "points",
          },
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
          }),
          ...commonInputs.contentInputs({
            includeTitle: true,
            includeContent: true,
          }),
          {
            name: "disclaimer",
            type: "longText",
            defaultValue: "Disclaimer text",
          },
        ],
      },
    ],
  });

  Builder.registerComponent(PointsCalculatorWithFees, {
    name: "Points Calculator With Fees",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({
        excludeMicroCopy: false,
      }),
      {
        name: "panelTitle",
        type: "text",
        friendlyName: "Panel title",
        defaultValue: "Calculate your points",
      },
      {
        name: "panelContent",
        type: "richText",
        friendlyName: "Panel content",
        defaultValue: "Enter an amount to see points and fees.",
      },
      {
        name: "disclaimer",
        type: "longText",
        defaultValue: "Disclaimer text",
      },
      {
        name: "conversionRateUnit",
        type: "text",
        defaultValue: "points",
      },
      {
        name: "rateSelectLabel",
        type: "text",
        friendlyName: "Rate selector label",
        defaultValue: "Rate",
      },
      {
        name: "amountLabel",
        type: "text",
        friendlyName: "Amount input label",
        defaultValue: "(2) Repayment amount",
      },
      // {
      //   name: "feeLabel",
      //   type: "text",
      //   friendlyName: "Fees label",
      //   defaultValue: "Fees",
      // },
      {
        name: "rateOptions",
        type: "list",
        helperText: "The first option is the default selection. Changing the rate recalculates points and fees.",
        defaultValue: [
          {
            label: "0 points per $1",
            conversionRate: 0.1,
            // feePercentage: 0.4,
          },
          {
            label: "0.25 points per $1",
            conversionRate: 0.25,
            // feePercentage: 0.8,
          },
          {
            label: "0.5 points per $1",
            conversionRate: 0.5,
            // feePercentage: 1,
          },
          {
            label: "0.75 points per $1",
            conversionRate: 0.75,
            // feePercentage: 1.3,
          },
          {
            label: "1 point per $1",
            conversionRate: 1,
            // feePercentage: 1.85,
          },
        ],
        subFields: [
          {
            name: "label",
            type: "text",
            defaultValue: "0 points per $1",
          },
          {
            name: "conversionRate",
            type: "number",
            friendlyName: "Points per $1",
            defaultValue: 0,
            helperText: "Points earned for each $1 entered.",
          },
          // {
          //   name: "feePercentage",
          //   type: "number",
          //   friendlyName: "Fee percentage",
          //   defaultValue: 0,
          //   helperText: "Fee as a percent of the amount. Enter 0.4 for 0.4%.",
          // },
        ],
      },
    ],
  });
};
